



































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import IScene from "../types/scene";
import { contextModule } from "../store/context";
import { ensureDarkColor } from "../util/color";
import Color from "color";
import SceneMixin from "../mixins/scene";

@Component
export default class SceneCard extends Mixins(SceneMixin) {
  @Prop(Object) value!: IScene;
  @Prop({ default: true }) showLabels!: boolean;

  playIndex = 0;
  playInterval = null as NodeJS.Timeout | null;

  get complementary() {
    if (this.cardColor) return Color(this.cardColor).negate().hex() + " !important";
    return undefined;
  }

  get cardColor() {
    if (this.value.thumbnail && this.value.thumbnail.color)
      return ensureDarkColor(this.value.thumbnail.color);
    return null;
  }

  get previewSceneOnMouseHover() {
    return contextModule.scenePreviewOnMouseHover;
  }

  mouseenter() {
    if (this.playInterval) clearInterval(this.playInterval);

    this.playIndex = 60;
    // @ts-ignore
    this.$refs.video.currentTime = this.playIndex;

    this.playInterval = setInterval(() => {
      this.playIndex += 180;

      if (this.playIndex > this.value.meta.duration) this.playIndex = 0;
      // @ts-ignore
      if (this.$refs.video) this.$refs.video.currentTime = this.playIndex;
    }, 5000);
  }

  mouseleave() {
    try {
      // @ts-ignore
      this.$refs.video.setAttribute("src", "");
    } catch (error) {}
    if (this.playInterval) {
      // console.log("stopping video");
      clearInterval(this.playInterval);
    }
  }

  beforeDestroy() {
    try {
      // @ts-ignore
      this.$refs.video.setAttribute("src", "");
    } catch (error) {}
  }

  destroyed() {
    if (this.playInterval) {
      // console.log("stopping video");
      clearInterval(this.playInterval);
    }
  }
}
